import { render, staticRenderFns } from "./PublicPageLayout.vue?vue&type=template&id=f96f8d7c&scoped=true"
import script from "./PublicPageLayout.vue?vue&type=script&lang=js"
export * from "./PublicPageLayout.vue?vue&type=script&lang=js"
import style0 from "./PublicPageLayout.vue?vue&type=style&index=0&id=f96f8d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96f8d7c",
  null
  
)

export default component.exports